import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "folder-person-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 7 }),
        React.createElement("path", { strokeLinecap: "round", d: "M4.624 11.522C5.027 9.792 6.609 8.5 8.5 8.5c1.89 0 3.473 1.292 3.875 3.022" }),
        React.createElement("circle", { cx: 8.5, cy: 6.5, r: 2 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
